import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.user');
import { OnInit, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'wiz-layout-user',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.user/view.scss */
/* src/app/layout.user/view.scss: no such file or directory */`],
})
export class LayoutUserComponent implements OnInit, OnDestroy {

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    @ViewChild('navToggle') navToggle: ElementRef<HTMLElement>;
    @ViewChild('navDrawer') navDrawer: ElementRef<HTMLElement>;
    @ViewChild('pageContent') pageContent: ElementRef<HTMLElement>;
    public isMobile = window.innerWidth < 768;
    public mobileNavOpen: boolean = false;
    private navSub: any;

    public async ngOnInit() {
        await this.service.init();
        this.navSub = this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe(async () => {
                if (this.mobileNavOpen) await this.closeMobileNav(false);
            });
    }

    public ngOnDestroy() {
        this.navSub?.unsubscribe();
    }

    public async toggleMobileNav() {
        if (this.mobileNavOpen) return this.closeMobileNav();
        this.mobileNavOpen = true;
        await this.service.render();
        if (this.mobileNavOpen) this.focusableItems()[0]?.focus({ preventScroll: true });
    }

    public async closeMobileNav(restoreToggle = true) {
        this.mobileNavOpen = false;
        await this.service.render();
        (restoreToggle && this.isMobile ? this.navToggle : this.pageContent)?.nativeElement.focus({ preventScroll: true });
    }

    private focusableItems(): HTMLElement[] {
        return Array.from(this.navDrawer?.nativeElement.querySelectorAll<HTMLElement>(
            'a[href], button:not([disabled]), [tabindex="0"]') || [])
            .filter(element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
    }

    @HostListener('window:resize')
    public async onResize() {
        this.isMobile = window.innerWidth < 768;
        if (!this.isMobile && this.mobileNavOpen) await this.closeMobileNav(false);
        await this.service.render();
    }

    @HostListener('document:keydown', ['$event'])
    public async onNavKeydown(event: KeyboardEvent) {
        if (!this.isMobile || !this.mobileNavOpen || this.service.alert?.isshow) return;
        if (event.key === 'Escape') {
            event.preventDefault();
            await this.closeMobileNav();
        } else if (event.key === 'Tab') {
            const items = this.focusableItems();
            const first = items[0], last = items[items.length - 1];
            if (!first) { event.preventDefault(); return; }
            if (event.shiftKey && (document.activeElement === first || !this.navDrawer.nativeElement.contains(document.activeElement))) {
                event.preventDefault(); last.focus({ preventScroll: true });
            } else if (!event.shiftKey && (document.activeElement === last || !this.navDrawer.nativeElement.contains(document.activeElement))) {
                event.preventDefault(); first.focus({ preventScroll: true });
            }
        }
    }
}

export default LayoutUserComponent;